/**
 * impleco contact form
 * https://impleco.atlassian.net/browse/WISCH-70
 */

import React, { useEffect, useState } from 'react';
import Checkbox from '../MaterialUi/Checkbox';
import Select, { ISelectProps } from '../MaterialUi/Select';
import TextField from '../MaterialUi/TextField';
import { IConcreteContactFormProps } from './ContactForm';
import styles from './ContactForm.scss'
import Button from '../MaterialUi/Button';



const Kontakt: React.FC<React.PropsWithChildren<IConcreteContactFormProps>> = ({ onSubmit }) => {

    const [formValues, setFormValues] = useState({ timestamppreventduplicates: `${Date.now()}_${Math.random()}`, id_wgn_form: 'Kontakt' })

    const onChange = (ev) => {
        const name = ev.target.name;
        const value = ev.target.value || ev.target.checked;
        setFormValues(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = (ev: React.FormEvent) => {
        ev.preventDefault();
        onSubmit(formValues).then(() => {
            setFormValues({ timestamppreventduplicates: `${Date.now()}_${Math.random()}`, id_wgn_form: 'Kontakt' })
        }
        )
    }

    return (
        <fieldset className={styles.contactForm}>
            <h2>Deine Anfrage an Wohnglück</h2>
            <form onSubmit={handleSubmit}>


                <Select onChange={onChange} name="betreff" value={formValues['betreff'] || ''} label="Um welches Thema geht es?">
                    <option value="Feedback zu Inhalten">Feedback zu Inhalten</option>
                    <option value="Frage an Experten">Frage an Experten</option>
                    <option value="Technische Fehlermeldung">Technische Fehlermeldung</option>
                    <option value="Werbung/Kooperation">Werbung/Kooperation</option>
                    <option value="Datenschutz">Datenschutz</option>
                    <option value="Wohnglück-Abonnement">Wohnglück-Abonnement</option>
                    <option value="Sonstiges">Sonstiges</option>
                </Select>

                <TextField multiline label="Darum geht's - das möchte ich wissen:" onChange={onChange} required={true} placeholder="Bitte hier möglichst ausführlich beschreiben, wie dir Wohnglück weiterhelfen kann." name="mitteilungstext" />

                <Select onChange={onChange} value={formValues['anrede']} label="Anrede" name="anrede">
                    <option value="Herr">Herr</option>
                    <option value="Frau">Frau</option>
                    <option value="Divers">Divers</option>
                </Select>

                <TextField onChange={onChange} value={formValues['vorname'] || ''} name="vorname" label="Vorname" required={true} type="text" />

                <TextField onChange={onChange} value={formValues['nachname'] || ''} name="nachname" label="Nachname" required={true} type="text" />

                <TextField onChange={onChange} value={formValues['strasse'] || ''} name="strasse" label="Straße" type="text" />

                <TextField onChange={onChange} value={formValues['hausnummer'] || ''} name="hausnummer" label="Hausnummer" type="text" />

                <TextField onChange={onChange} value={formValues['plz'] || ''} name="plz" label="PLZ" type="text" />

                <TextField onChange={onChange} value={formValues['ort'] || ''} name="ort" label="Ort" type="text" />

                <TextField onChange={onChange} value={formValues['telefon_vorwahl'] || ''} name="telefon_vorwahl" label="Telefon-Vorwahl" type="text" />

                <TextField onChange={onChange} value={formValues['telefon_rufnummer'] || ''} name="telefon_rufnummer" label="Telefon-Rufnummer" type="text" />

                <TextField onChange={onChange} value={formValues['email'] || ''} name="email" required={true} label="E-Mail" type="email" />

                <h4>
                    Datenverwendung und Datenschutz<span className="mandatory">*</span>
                </h4>
                <div className={styles.terms}>
                    <Checkbox onChange={onChange} label={
                        <>
                            <b>Ich bestätige, dass ich folgenden Hinweis zum Datenschutz und zur Datenverwendung zur Kenntnis genommen und akzeptiert habe:</b>
                            {' '}Wir speichern Deine Daten zum Zwecke und für die Dauer der Beantwortung Deiner Anfrage.
                            Nähere Angaben zum Umgang mit Deinen personenbezogenen Daten und zu Deinen Rechten findest Du in unserer
                            {' '}<b><a href="https://wohnglueck.de/info/datenschutz" target="_blank">Datenschutzerklärung</a></b>.
                        </>
                    } required name="datenverwendungunddatenschutz" value={formValues['datenverwendungunddatenschutz']} />
                </div>

                <div className={styles.thanks}>
                    Vielen Dank, dass Du die mit * markierten Pflichtfelder ausfüllst.
                </div>

                <div className={styles.actions}>
                    <Button type="submit" color="primary">Anfrage absenden</Button>
                </div>
            </form>

        </fieldset>
    );
};

export default Kontakt;
